<template>
    <section
        class="o-flexible-module"
        :class="{ 'o-flexible-module--flush': settings.spacing == 'flush' }">
        <div class="grid-container" v-if="settings.showComponentTitle">
            <div class="grid-x grid-margin-x">
                <div class="small-12 cell">
                    <div class="utl-heading-beta">
                        {{ settings.componentTitle || 'Hero Video' }}
                    </div>
                </div>
            </div>
        </div>

        <div
            :class="`c-hero-video c-hero-video--${settings.theme} js-hero-video`"
            data-aos="fade-up">
            <div class="grid-container">
                <div class="grid-x grid-margin-x">
                    <div class="small-12 cell">
                        <div class="c-hero-video__wrapper">
                            <div
                                class="c-hero-video__meta js-hero-video__meta"
                                :class="{ 'is-streamyard': videoSource == 'streamyard' }">
                                <div class="c-hero-video__poster" v-if="videoSource == 'streamyard' && image">
                                    <img
                                        :srcset="image.srcSet"
                                        :sizes="image.sizes"
                                        :src="image.sourceUrl" />
                                </div>

                                <div class="c-hero-video__title-wrapper">
                                    <div class="c-hero-video__pretitle" v-if="pretitle">
                                        {{ pretitle }}
                                    </div>

                                    <h2 class="c-hero-video__title">
                                        {{ title }}
                                    </h2>
                                </div>

                                <div class="c-hero-video__play-wrapper">
                                    <button class="c-hero-video__play" type="button" :aria-label="`Play ${title}`" @click="playVideo($event)"></button>
                                </div>
                            </div>

                            <template v-if="videoSource == 'youtube'">
                                <lite-youtube
                                    class="c-hero-video__embed js-hero-video__embed"
                                    :videoid="$convertVideoId(video)"
                                    :playlabel="`Play ${title}`"
                                    params="modestbranding=1&rel=0&enablejsapi=1"
                                    :style="image ? `background-image: url('${image.sourceUrl}');` : ''" />
                            </template>

                            <template v-else>
                                <div class="js-hero-video__streamyard" v-html="streamyardEmbedCode"></div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
    const props = defineProps({
        pretitle: {
            type: String,
            required: false
        },
        title: {
            type: String,
            required: true
        },
        videoSource: {
            type: String,
            required: true
        },
        video: {
            type: String,
            required: false
        },
        streamyardEmbedCode: {
            type: String,
            required: false
        },
        image: {
            type: Object,
            required: true
        },
        settings: {
            theme: {
                type: String,
                required: true
            },
            showComponentTitle: {
                type: Boolean,
                required: true,
            },
            spacing: {
                type: String,
                required: true
            }
        }
    });

    const playVideo = (event) => {
        const $target = event.target;
        const $parent = $target.closest('.js-hero-video__meta');

        $parent.style.display = 'none';

        if(!$parent.classList.contains('is-streamyard')) {
            const $embed = $target.closest('.js-hero-video').querySelectorAll('.js-hero-video__embed')[0];
            $embed.click();
        };
    };
</script>
